export default {"src":"/_next/static/media/iconClose.a2ca72ba.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};